import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, inject, viewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationModalCloseType, ConfirmationModalData } from '../../../models';
import { ServiceProviderWorkflow } from '../../../closing-cost-worksheet-15/models/ccw.enums';
import { CCWService } from '../../../closing-cost-worksheet-15/services/ccw-service';
import { AsyncPipe } from '@angular/common';
import { RadioButton } from 'primeng/radiobutton';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ButtonDirective } from 'primeng/button';

export interface extendedModalData extends ConfirmationModalData {
  ccwSelectServiceProvider?: {
    selectedServiceProvider?: string;
  };
}
/**
 * ConfirmationModalComponent combined with dialogService should
 * be used for confirm modals everywhere going forward as PrimeNg's
 * confirmation modal is not easily customized to our UI standards.
 * The interface is very similar to confirmation service.
 */
@Component({
  selector: 'cmg-clear2-ui-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RadioButton, ReactiveFormsModule, FormsModule, ButtonDirective, AsyncPipe],
})
export class ConfirmationModalComponent implements OnInit, AfterViewInit {
  config = inject(DynamicDialogConfig);
  private readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _ccwService = inject(CCWService);

  readonly acceptButton = viewChild<ElementRef>('acceptButton');
  modalData?: extendedModalData = {
    header: 'Confirmation',
    acceptLabel: 'Yes',
    rejectLabel: 'No',
    acceptIcon: '',
    rejectIcon: '',
    acceptVisible: true,
  };
  serviceProviderOptions = Object.values(ServiceProviderWorkflow);
  isSpecificProviders = false;

  isCcwDisabled$ = this._ccwService.isCcwDisabled$;

  ngOnInit(): void {
    this.config.closeOnEscape = false;
    this.modalData = Object.assign(this.modalData, this.config.data);
    if (this.modalData?.ccwSelectServiceProvider?.selectedServiceProvider === ServiceProviderWorkflow.SpecificProviders) {
      this.isSpecificProviders = true;
    }
  }

  ngAfterViewInit() {
    // tried pAutoFocus directive, it didn't work, so now
    // doing it manually
    setTimeout(
      (acceptButton: ElementRef) => {
        acceptButton?.nativeElement?.focus();
      },
      250,
      this.acceptButton(),
    );
  }

  accept() {
    if (this.modalData?.ccwSelectServiceProvider?.selectedServiceProvider) {
      const serviceProviderToPass = {
        selectServiceProvider: this.modalData.ccwSelectServiceProvider.selectedServiceProvider,
        closedViaAcceptButton: ConfirmationModalCloseType.ClosedViaAcceptButton,
      };
      this._dialogRef.close(serviceProviderToPass);
    } else {
      this._dialogRef.close(ConfirmationModalCloseType.ClosedViaAcceptButton);
    }
  }

  reject() {
    this._dialogRef.close(ConfirmationModalCloseType.ClosedViaRejectButton);
  }

  report() {
    this._dialogRef.close(ConfirmationModalCloseType.ClosedViaReportButton);
  }

  // NOTE
  // If DynamicDialogConfig.closeable is true, when user clicks the X in top right corner, PrimeNG will call _dialogRef.close with a value of undefined.
}
